import { NewsFeedHighConfidenceTabs } from "../../../../utils/AllFilterTabs";
import { indexOfObject } from "../../../../utils/ArrayUtils";
import { dateFormator, datepicker_input_format, getDateUtil } from "../../../../utils/dateUtils";
import { NewPostFilterOptions } from "../../../../utils/PostFilterOptions";
import { countSelectedFilters } from "../../utils/CountSeletectedFilters";

const high_conf_dates = {
  created_at: { defaultPresetKey: 'all_time', presetType: 'date_ranges', value: { from: null, to: null }, label: "Posted on", maxDate: dateFormator(new Date()) },
  article_created_date: { defaultPresetKey: 'all_time', presetType: 'date_ranges', value: { from: null, to: null }, label: "Published on", maxDate: dateFormator(new Date()) },
};

const low_conf_dates = {
  created_at: { defaultPresetKey: 'all_time', presetType: 'date_ranges', value: { from: null, to: null }, label: "Created at", maxDate: dateFormator(new Date()) },
};
export const high_conf_sort = [
    {value: "created_at-desc", label: "Published at: Newest to Oldest", is_default: true, short_label: 'Published at: N-O'},
    {value: "created_at-asc", label: "Published at: Oldest to Newest", short_label: 'Published at: O-N'}, 
    {value: "article_created_date-desc", label: "Created at: Newest to Oldest", short_label: 'Created at: N-O'},
    {value: "article_created_date-asc", label: "Created at: Oldest to Newest", short_label: 'Created at: O-N'}, 
]
const low_conf_sort = [
    {value: "article_created_date-desc", label: "Created at: Newest to Oldest", is_default: true, short_label: 'Created at: N-O'},
    {value: "article_created_date-asc", label: "Created at: Oldest to Newest", short_label: 'Created at: O-N'}, 
]
export const initialDropDownFilterList = {viewType: 'all', containComment: 'all', containSuggestion: 'all', activeViewType: 'news_results', review: 'all'}
const initialAggregatesData = {
    sort: [...high_conf_sort],
    tags: [],
    assigns: [],
    type: [],
    location: [],
    company: [],
    title: [],
    college: [],
    mentioned_for: [],
    sec_category: [],
    miscellaneous: [],
    score_tags: [],
    graduation_year: [],
}
export const initialFiltersState = {
    filtersSelected: {
        sort: [],
        tags: [],
        assigns: [],
        type: [],
        location: [],
        company: [],
        title: [],
        college: [],
        mentioned_for: [],
        sec_category: [],
        miscellaneous: [],
        score_tags: [],
        graduation_year: []
    },
    dateRanges: {...high_conf_dates},
    aggregatesData: initialAggregatesData,
    searchedAggregatesData: initialAggregatesData,
    popupsList: {showFilterPopup: false},
    showDateFilterPopup: false,
    activeFilterTab: NewsFeedHighConfidenceTabs[0],
    appliedFiltersCount: 0,
    confidenceType: "high",
    postType: "all",
    dropDownFilterlist: {...initialDropDownFilterList},
    searchTerm: "",
    actualSearchTerm: ""
};

export const newsFeedFilterReducer = (state, action) => {
    let {payload} = action;
    switch (action.type) {
        case "ASSIGN_AGGREGATES_DATA":
            return {
                ...state,
                aggregatesData: { ...state.aggregatesData, ...action.payload.aggregates },
                popupsList: {[action.payload.popup || "showFilterPopup"]: false},
                loaders: {filtersSubmitLoader: false}
            };
        case "ASSIGN_SEARCHED_AGGREGATES": {
                let {aggregates, mappedKey} = action.payload;
                let newAggregates = {...state.searchedAggregatesData};
                newAggregates[mappedKey] = [...aggregates]
                return {
                    ...state,
                    searchedAggregatesData: newAggregates,
                };
            }
        case "ASSIGN_SPECIFIC_AGGREGATES_DATA":
            let aggregatesData = { ...state.aggregatesData };
            return {
                ...state,
                aggregatesData: {
                    ...aggregatesData,
                    [action.payload.filter_type]: action.payload.aggregates,
                },
            };
        case "APPLY_TEMP_FILTERS": {
            let new_state = {
                ...state,
                filtersSelected: { ...action.payload.filtersSelected },
                appliedFiltersCount: countSelectedFilters(action.payload.filtersSelected),
            }
            if(action.payload.dateRanges)
                new_state.dateRanges = action.payload.dateRanges
            return new_state;
        }
        case "SELECTED_FILTER": {
            let filtersSelected = { ...state.filtersSelected };
            let aggregatesData = {...state.aggregatesData}
            let {mappedKey, selectedVal} = action.payload
            let selections = action.payload.selections || [...(filtersSelected[mappedKey] || [])]
            let agg_selections = [...(aggregatesData[mappedKey] || [])]
            if(!action.payload.selections){
                let index = selections?.indexOf(selectedVal);
                let agg_index = indexOfObject(agg_selections, "term", selectedVal)
                if(index===-1){
                    selections = [...selections, selectedVal]
                    if(agg_index === -1 && action.payload.selectedAgg)
                        agg_selections = [action.payload.selectedAgg, ...agg_selections]
                }
                else
                    selections.splice(index, 1)
            }
            aggregatesData[mappedKey] = [...agg_selections]            
            let newFiltersSelected = {
                ...filtersSelected,
                [action.payload.mappedKey]: selections,
            };
            return { ...state, 
                filtersSelected: newFiltersSelected,
                aggregatesData: aggregatesData,
                appliedFiltersCount: countSelectedFilters(newFiltersSelected)
            };
        }      
        case "SELECT_ALL_FILTER": {
            let {mappedKey, tagsList, allSelect} = action.payload
            let {filtersSelected, aggregatesData} = state;
            let selections = [...(filtersSelected[mappedKey] || [])]
            let agg_selections = [...(aggregatesData[mappedKey] || [])]
            tagsList.filter(tag => tag.term !== null && tag.term !== undefined).map(tag => {
                let index = selections?.indexOf(tag.term);
                if(index===-1 && !allSelect){
                    selections = [...selections, tag.term]
                    let aggregateNotExist = indexOfObject(aggregatesData[mappedKey], "term", tag.term) === -1
                    if(aggregateNotExist)
                    agg_selections = [tag, ...agg_selections]
                }
                if(index !== -1 && allSelect)
                    selections.splice(index, 1)
            })
            let newFiltersSelected = {
                ...filtersSelected,
                [mappedKey]: selections,
            };
            let newAggregates = {
                ...aggregatesData,
                [mappedKey]: agg_selections,
            };
            return { ...state, 
                allSelect: !allSelect,
                filtersSelected: newFiltersSelected,
                aggregatesData: newAggregates,
                appliedFiltersCount: countSelectedFilters(newFiltersSelected)
            };
        }  
        case "SELECT_AND_MODIFY": {
            let { mappedKey } = action.payload;
            let insertAt = "PREPEND"
            if(action.payload.insertAt) insertAt = action.payload.insertAt
            let newFiltersSelected = [
                ...(state.filtersSelected[mappedKey] || []),
                action.payload.data.term,
            ];
            let finalFilters = {
                ...state.filtersSelected,
                [mappedKey]: newFiltersSelected,
            };

            let appendedAggregates = []
            if(insertAt == "PREPEND"){
                appendedAggregates = [
                    action.payload.data,
                    ...state.aggregatesData[mappedKey],
                ];
            }else{
                appendedAggregates = [
                    ...state.aggregatesData[mappedKey],
                    action.payload.data,
                ];
            }
            
            let finalAggregates = {
                ...state.aggregatesData,
                [mappedKey]: appendedAggregates,
            };

            return {
                ...state,
                filtersSelected: finalFilters,
                aggregatesData: finalAggregates,
                appliedFiltersCount: countSelectedFilters(finalFilters)
            };
        }
        case "SET_ACTIVE_FILTER_SUB_TAB":{
            let {payload} = action;
            let allFilterTabs = payload.allFilterTabs || NewsFeedHighConfidenceTabs;
            let index = indexOfObject(allFilterTabs, "tab_key", payload.activeFilterTabKey);
            let activeFilter = allFilterTabs[index];
            return { ...state, activeFilterTab: activeFilter };
        }
        case "SET_POPUP":
            return { ...state, popupsList: {[action.payload.popup || "showFilterPopup"]: action.payload.showable }};
        case "CLEAR_SELECTED_FILTERS":{
            //clear custom filters as well
            let {allFilterTabs} = action.payload;
            let newFiltersSelected = {...initialFiltersState.filtersSelected}
            allFilterTabs?.forEach(item => {
                if(item.is_custom){
                    newFiltersSelected[item.tab_key] = []
                }
            })
            return {
                ...state,
                filtersSelected: newFiltersSelected,
                appliedFiltersCount: 0
            };
        }
        case "UPDATE_DATE_RANGE":
            let {dateRanges} = state;
            let temp = dateRanges[payload.key];
            return {
                ...state,
                dateRanges: {...dateRanges, [payload.key]: {...temp, [payload.subkey]: payload.value}}
            };
        case "APPLY_DATE_RANGES": {
            let new_state = {...state};            
            new_state.dateRanges = action.payload.dateRanges
            return new_state;
        }
        case "CLEAR_DATE_RANGES": {
            let new_state = {...state};
            if(action.payload?.confidenceType)
                new_state.confidenceType = action.payload.confidenceType
            
            if(new_state.confidenceType == "low") {
                new_state.dateRanges = {...low_conf_dates}
            }
            else if(new_state.confidenceType == "mid") {
                new_state.dateRanges = {...low_conf_dates}
            }
            else{
                new_state.dateRanges = high_conf_dates
            }
            return new_state;
        }
        case "RESET_FILTER": {
            let new_state = {...state};
            let {allFilterTabs} = action.payload;
            let newFiltersSelected = {...initialFiltersState.filtersSelected}
            let newAggregatesData = {...initialFiltersState.aggregatesData}
            if(action.payload?.confidenceType)
                new_state.confidenceType = action.payload.confidenceType

            if(new_state.confidenceType == "low") {
                new_state.dateRanges = {...low_conf_dates}
                newAggregatesData.sort = [...low_conf_sort]
            }
            else if(new_state.confidenceType == "mid") {
                new_state.dateRanges = {...low_conf_dates}
                newAggregatesData.sort = [...low_conf_sort]
            }
            else{
                new_state.dateRanges = high_conf_dates
                newAggregatesData.sort = [...high_conf_sort]
            }
            allFilterTabs?.forEach(item => {
                if(item.is_custom){
                    newFiltersSelected[item.tab_key] = []
                }
            })
            new_state.aggregatesData = newAggregatesData
            new_state.filtersSelected = newFiltersSelected
            new_state.appliedFiltersCount = countSelectedFilters(newFiltersSelected);
            new_state.dropDownFilterlist = initialDropDownFilterList
            return new_state
        }
        case "SET_STATE": {
            return {...state, ...action.payload}
        }
        case "SET_PRESET":{
            return {
                ...state,
                dateRanges: {
                ...state.dateRanges,
                [action.payload.tab]: {
                    ...state.dateRanges[action.payload.tab],
                    preset: action.payload.preset,
                    value: action.payload.value,
                },
                },
            };
        }
        default:
            return { ...state };
    }
};
